import React, { createContext, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useMessage } from "./MessageHandler/MessageService";

const socket = new WebSocket(process.env.REACT_APP_WS_BRIDGE_PROTOCOL + '://' + process.env.REACT_APP_WS_BRIDGE_HOST + ':' + process.env.REACT_APP_WS_BRIDGE_PORT);

// Contesto websocket
export const WebSocketContext = createContext<WebSocket | null>(null);

export const WebSocketProvider = ({ children }: { children: React.ReactNode }) => {
	useEffect(() => {
		socket.onopen = () => {
			console.log("Connessione al WebSocket aperta");
			toast.success("Connessione riuscita", { autoClose: 2000 });
		};

		socket.onerror = () => {
			console.log("Connessione non riuscita");
			toast.error("Connessione non riuscita", { autoClose: 2000 })
		}
	}, []);

	return (
		<WebSocketContext.Provider value={socket}>
			{children}
		</WebSocketContext.Provider>
	);
};

export const useWebSocket = () => {
	return useContext(WebSocketContext);
};

const WebSocketComponent = () => {
	const socket = useContext(WebSocketContext);
	const messaggio = useMessage();
	const Naviga = useNavigate();

	useEffect(() => {
		// Apri Connessione 
		if (socket) {
			socket.onmessage = (event) => {
				const parsedData = JSON.parse(event.data)
				if (parsedData.header.source === "server" && parsedData.header.event === "error") {
					switch (parsedData.body.errorCode) {
						case 101:
						case 102:
						case 103:
						case 104:
							messaggio({
								title: "Error",
								description: parsedData.body.errorMessage,
								okCallback: () => Naviga(0),
								okLabel: "Ok"
							})
							break;
					}
				}
			};

			socket.onerror = (error) => {
				console.error("Errore Websocket:", error);
				socket.close();
			};
		}
	}, [socket, Naviga, messaggio]);

	return (
		<>
			<ToastContainer autoClose={5000} position="top-right" />
		</>
	);
};

export default WebSocketComponent;